export default __webpack_public_path__ + "static/media/hht1_ani_08.39553f5b.png";